<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
    <path
      d="M16.36,11.69H12.64L10,14.25,7.36,11.69H3.64L1,14.25v5.57H19V14.25Z"
      fill="currentColor"
    />
    <path
      d="M14.85,3,11.8.18H7.51L4.46,3v4L7.51,9.66H11.8l3-2.59Z"
      fill="currentColor"
    />
  </svg>
</template>
